module.exports = __webpack_public_path__ + "static/media/ayush_shah.8c983d77.jpg";